import "./header.css"
import CTA from './CTA'
import HeaderSocials from './HeaderSocials'
import { useTranslation } from "react-i18next";
import LanguageSwitch from "../languageSwitch/LanguageSwitch"


const Header = () => {
  const { t } = useTranslation();

  return (
    <header>
      
        <div className="container header__container">
      
          <h5>{t("title")}</h5>
          <h1>João Victor</h1>
          <h5 className="text-light">{t("subtitle")}</h5>
          <CTA />
          <LanguageSwitch/>
          <HeaderSocials />

          <a href="#about" className='scroll__down'>Scroll Down</a>
        </div>
      
    </header>
  )
}

export default Header